import './main.scss';

import initHeader from './js/helpers/header';
import initDesktopMenu from './js/helpers/desktop-menu';
import initMobileMenu from './js/helpers/mobile-menu';
import initSliders from './js/helpers/sliders';
import initReadMore from './js/helpers/read-more';

jQuery(function () {
  initHeader();
  initDesktopMenu();
  initMobileMenu();
  initSliders();
  initReadMore();
});
